import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useRecoilValue, useRecoilCallback } from 'recoil'

import { SearchForm, Item, Group, FormLabel } from 'mailup-web-components'

import {
  InputSearchString,
  InputTags,
  InputStatus,
  InputType,
  InputMessages
} from './components'

import { resultsStateSearchParams } from 'Pages/AbTestList/recoil/state/results'
import {
  searchTestsCallback,
  resetSearchCallback
} from 'Pages/AbTestList/recoil/callbacks/callbacks'

const Search = () => {
  const intl = useIntl()
  const [expanded, setExpanded] = useState(false)

  const resultsSearchParams = useRecoilValue(resultsStateSearchParams)
  const fetchResults = useRecoilCallback(searchTestsCallback, [])
  const resetSearch = useRecoilCallback(resetSearchCallback, [])

  const values = useRef(resultsSearchParams)
  useEffect(() => {
    values.current = resultsSearchParams
  }, [resultsSearchParams])

  const handleInputChange = (key, val) => {
    values.current = {
      ...values.current,
      [key]: val
    }
  }

  const handleSubmit = () => {
    fetchResults()
  }

  const handleReset = () => {
    resetSearch()
  }

  const AdvancedSearchComponent = () => (
    <AdvancedSearch onInputChange={handleInputChange} />
  )

  return (
    <SearchForm
      advanced
      labelBtnReset={intl.formatMessage({ id: 'Load.MailupCommon.Reset' })}
      labelBtnSearch={intl.formatMessage({ id: 'Load.MailupCommon.Search' })}
      expanded={expanded}
      AdvancedSearchComponent={AdvancedSearchComponent}
      onClickToggle={() => setExpanded(prev => !prev)}
      onClickReset={handleReset}
      onSubmit={handleSubmit}
      submitClassName='test-searchButton'
      resetClassName='test-resetButton'
    >
      <Group>
        <Item>
          <InputSearchString
            onChange={e => {
              handleInputChange('searchText', e.target.value)
            }}
          />
        </Item>
      </Group>
    </SearchForm>
  )
}

const AdvancedSearch = ({ onInputChange }) => {
  const intl = useIntl()

  return (
    <>
      <>
        <Group of={3}>
          <Item>
            <InputTags onChange={value => onInputChange('filterTags', value)} />
          </Item>
        </Group>
        <Group of={3}>
          <FormLabel>
            {intl.formatMessage({ id: 'Load.MailupCommon.Status' })}
          </FormLabel>
          <Item>
            <InputStatus
              onChange={value => onInputChange('filterStatus', value)}
            />
          </Item>
        </Group>
        <Group of={3}>
          <FormLabel>
            {intl.formatMessage({ id: 'Load.MailupCommon.Type' })}
          </FormLabel>
          <Item>
            <InputType onChange={value => onInputChange('filterType', value)} />
          </Item>
        </Group>
        <Group wide>
          <Item>
            <InputMessages
              onChange={value => onInputChange('filterMessages', value)}
            />
          </Item>
        </Group>
      </>
    </>
  )
}

AdvancedSearch.propTypes = {
  onInputChange: PropTypes.func
}

export default Search
